
import { mapState, mapActions } from 'vuex'
import moment from 'moment'

export default {
  data() {
    return {
      values: {},
      formData: {},
      schema: [],
      formErrors: [],
      inputErrors: {},
      success: false,
      failed: false
    }
  },
  async mounted() {
    this.schema = await this.blok.fields.map((s) => {
      const options =
        s.options && s.options.length ? s.options.map((o) => o.value) : null
      const max = s.max
        ? s.max === 'today'
          ? this.$dayjs().format('YYYY-MM-DD')
          : s.max
        : ''

      // '@change': (e) => e.target.value === 'Fiji' ? alert('🏝') : alert('🤔')
      // const buttonEvent = s.button_event
      //   ? (e) => (e.target.value === 'Fiji' ? alert('🏝') : alert('🤔'))
      //   : ''

      return {
        type: s.type,
        name: s.name,
        label: s.html_label ? '' : s.label,
        customLabel: s.html_label,
        placeholder: s.placeholder,
        validation: s.rules,
        help: s.help,
        'validation-name': s.validation_name ? s.validation_name : s.label,
        options,
        max,
        link: s.button_link,
        wrapperClass: s.wrapper_class,
        outerClass: s.outer_class,
        labelClass: s.label_class
          ? s.label_class
          : 'font-body font-bold text-xl uppercase block',
        helpClass: s.help_class ? s.help_class : 'text-xs mb-1 text-pepper',
        id: s.id ? s.id : null
      }
    })

    // Remove role attribute from errors for ADA
    MutationObserver = window.MutationObserver || window.WebKitMutationObserver
    const observer = new MutationObserver(function (mutations, observer) {
      // fired when a mutation occurs
      const errors = document.querySelectorAll('[role="status"]')
      errors.forEach((error) => {
        error.removeAttribute('role')

        // Only add aria-label to first error
        if (error.textContent.includes('*')) {
          error.setAttribute('aria-label', ('Error: ' + error.textContent).replace('*', ''))
        }
      })
    })
    // define what element should be observed by the observer
    // and what types of mutations trigger the callback
    observer.observe(document.querySelector('form'), {
      subtree: true,
      attributes: true
    })

    // // Add aria-label to checkboxes
    // this.$nextTick(() => {
    //   const checkboxes = document.querySelectorAll('[data-type="richcheckbox"]')

    //   checkboxes.forEach((checkbox) => {
    //     const input = checkbox.querySelector('input')
    //     const label = checkbox.querySelector('p').textContent
    //     input.setAttribute('aria-label', label)
    //   })
    // })
  },
  props: {
    blok: {
      type: Object,
      default: () => { }
    }
  },
  methods: {
    ...mapActions([
      'accountLogout' // also supports payload `this.nameOfAction(amount)`
    ]),
    resetForm() {
      this.formData = this.emtpyData
      //   requestAnimationFrame(() => {
      //     this.$refs[this.blok.form_name].reset()
      //   })
    },
    async submitHandler(data) {

      /*      this.$store.commit('setLoading', true)
      try {
        await this.$store.dispatch(`forms/${this.blok.form_event}`, data)
        this.$store.commit('setLoading', false)
        this.success = true
        this.failed = false
      } catch (error) {
        this.success = false
        this.failed = true
      }
      */
      console.log("Submit Handler")
      let response = null
      switch (this.blok.form_event) {
        case 'signup':
        case 'login':
          if (this.blok.form_event === 'signup') {
            const signup = await this.$api.createUser(data)
            if (signup) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                'event': 'sign_up',
                method: 'email',
              });

              //Check for the current Signup in Braze before creating a new account
              const alias = await this.$api.exportUserProfileById({
                "email": data.email,
                "fields_to_export": ["user_aliases", "email", "external_id"]
              })
              if (alias?.data?.users?.length) {
                const user_alias = alias.data.users.find(user => {
                  return user.user_aliases.find(_alias => {
                    return _alias.alias_label == 'wisely' && !user.external_id
                  })
                })
                // Alias without External ID and Wisely Alias was found
                if (user_alias && user_alias.user_aliases?.length) {
                  const identify = await this.$api.usersIdentify({
                    "aliases_to_identify": [
                      {
                        "external_id": user.id,
                        "user_alias": user_alias.user_alias.user_aliases[0]
                      }
                    ],
                    "merge_behavior": "merge"
                  })
                }
              }

              response = await this.$api.loginUser({
                username: data.email,
                password: data.password
              })
            }
          } else {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              'event': 'login',
              method: 'email',
            });
            response = await this.$api.loginUser(data)
          }
          if (response && response.status && response.status == 200) {
            const user = await this.$api.getUser()
            if (user) {
              const alias = await this.$api.exportUserProfileById({
                "email_address": user.email,
                "fields_to_export": ["email", "external_id"]
              })
              if(alias?.data?.users?.length) {
                //Account returned from matching email address check which ID to use to login the user
                let external_id = alias.data.users[0].external_id
                this.$braze.changeUser(external_id)
              }
              this.$braze.openSession()
              //Set either Catering or Ordering External ID to identify the user later
              if (this.channel === 'catering') {
                this.$braze.getUser().setCustomUserAttribute('catering_external_id', user.id)
              }
              else {
                this.$braze.getUser().setCustomUserAttribute('default_external_id', user.id)
              }

              const walletOffers = await this.$api.getWalletOffers()
              let offers = []
              walletOffers.rewards.forEach(offer => {
                const notExpired = moment.utc(offer.expires).isSameOrAfter(moment.utc().startOf('day'))
                if (offer.status == 'incomplete' && notExpired) {
                  offers.push(offer)
                }
              })
              this.$store.commit('setWalletOffers', offers)

              if (this.redirect) {
                this.$router.push(this.redirect)
              } else {
                this.$router.push('/account')
              }
            }
          } else if (response && response.status && response.status == 409) {
            if (response.data.required.indexOf('first_name') > -1 || response.data.required.indexOf('last_name') > -1) {
              this.$router.push(`/account/complete?email=${encodeURIComponent(data.username)}&password=${encodeURIComponent(data.password)}&provider=wiselyfix&required=${response.data.required.join(',')}`)
            } else {
              this.$router.push(`/account/complete?email=${encodeURIComponent(data.username)}&password=${encodeURIComponent(data.password)}&first_name=${encodeURIComponent(response.data.user.first_name)}&last_name=${encodeURIComponent(response.data.user.last_name)}&provider=password&required=${response.data.required.join(',')}`)
            }
          } else if (response) {
            this.$store.commit('setErrors', [response.data.message])
          }
          break
        case 'findlocation':
          // eslint-disable-next-line no-case-declarations
          const findlocation = await this.$api.findLocations(data)
          if (findlocation) this.$formulate.reset('findlocation')
          break
        case 'eclub':
          // eslint-disable-next-line no-case-declarations
          const eclub = await this.$api.subscribe(data)
          if (eclub) {
            this.success = true
            setTimeout(() => {
              this.success = false
              this.$formulate.reset('eclub')
            }, 1000)
          }
          break
        case 'reset-password':
          // eslint-disable-next-line no-case-declarations
          const reset = await this.$api.changePassword(
            data.newpassword,
            data.oldpassword
          )
          if (reset === '') {
            this.success = true
            // Access token becomes invalid after password change, so need to re-login
            this.accountLogout()
            this.$formulate.reset('reset-password')
            setTimeout(() => {
              this.$router.push('/')
            }, 1000)
          }
          break
        case 'forgot-password':
          await this.$api.forgotPassword(data.username)
          this.success = true
          this.$formulate.reset('forgot-password')
          break
        case 'franConnectEmail':
          const franchise = await this.$submit.send('franConnectEmail', data, data.email, 'Bojangles Franchising Website Leads', false)
          if (franchise) {
            this.success = true
            // this.$formulate.reset('franchising')
            setTimeout(function () {
              this.$router.push('/franchising/thank-you/')
            }.bind(this), 500)
          }
          break
        case 'password-reset':
          if (data.newpassword == data.confirmpassword) {
            const reset = await this.$api.resetPassword(this.$route.query.magic_token, this.$route.query.email, data.newpassword)
            if (reset) {
              this.success = true
              this.$formulate.reset('password-reset')
              setTimeout(() => {
                this.$router.push('/account/login')
              }, 1000)
            }
          } else {
            this.inputErrors = {
              confirmpassword: 'Password fields must match.'
            }
          }
          break
        case 'realestateEmail':
          const realestate = await this.$submit.send('realestateEmail', data, data.email, 'Bojangles Real Estate Leads', false)
          if (realestate) {
            this.success = true
            // this.$formulate.reset('realestate')
            setTimeout(function () {
              this.$router.push('/franchising/thank-you/')
            }.bind(this), 500)
          }
          break
        default:
          this.$formulate.reset(this.blok.form_event)

      }
    },
    invalidMessage(fields) {
      const fieldNames = Object.keys(fields)
      const listOfNames = fieldNames.map(
        (fieldName) => ' ' + fieldName.replace('_', ' ')
      )
      return `(Error) Invalid fields: ${listOfNames}`
    }
  },
  computed: {
    ...mapState(['redirect', 'errors']),
    emtpyData() {
      return this.blok.form_fields.map(() => {
        return ''
      })
    },
    classes() {
      return this.blok.classes ? this.blok.classes : ''
    },
    formClasses() {
      return this.blok.inner_form_class ? this.blok.inner_form_class : ''
    }
  }
}
